import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Delete, Block, Restore } from "@mui/icons-material";
import dayjs from "dayjs";
import api from "../../services/api";
import SeedAvailabilitySection from "./SeedAvailabilitySection";

const AdminSlotManager = () => {
  const [date, setDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [slots, setSlots] = useState([]);
  const [newSlot, setNewSlot] = useState({ time: "", max: 4 });

  const fetchAvailability = async () => {
    const { data } = await api.get(`/availability/${date}`);
    setSlots(data.slots);
  };

  useEffect(() => {
    fetchAvailability();
  }, [date]);

  const updateSlot = async (index, key, value) => {
    const updated = [...slots];
    updated[index][key] = value;
    setSlots(updated);
  };

  const saveAll = async () => {
    await api.patch(`/availability/${date}/admin`, {
      updates: slots.map(({ time, max, remaining }) => ({
        time,
        max,
        remaining,
      })),
    });
    fetchAvailability();
  };

  const resetSlots = async () => {
    await api.patch(`/availability/${date}/admin`, { reset: true });
    fetchAvailability();
  };

  const closeSlot = async (time) => {
    await api.delete(`/availability/${date}/slot`, {
      data: { time, close: true },
    });
    fetchAvailability();
  };

  const deleteSlot = async (time) => {
    await api.delete(`/availability/${date}/slot`, {
      data: { time, delete: true },
    });
    fetchAvailability();
  };

  const addSlot = async () => {
    await api.patch(`/availability/${date}/admin`, {
      addSlot: {
        ...newSlot,
        remaining: newSlot.max,
      },
    });
    setNewSlot({ time: "", max: 4 });
    fetchAvailability();
  };

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Manage Slots for {date}
      </Typography>

      <TextField
        label="Select Date"
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Paper variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>Remaining</TableCell>
              <TableCell>Max</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {slots.map((slot, index) => (
              <TableRow key={slot.time}>
                <TableCell>{slot.time}</TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    value={slot.remaining}
                    type="number"
                    onChange={(e) =>
                      updateSlot(index, "remaining", +e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    value={slot.max}
                    type="number"
                    onChange={(e) => updateSlot(index, "max", +e.target.value)}
                  />
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() => closeSlot(slot.time)}
                    title="Close Slot">
                    <Block />
                  </IconButton>
                  <IconButton
                    onClick={() => deleteSlot(slot.time)}
                    title="Delete Slot">
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Box mt={3} display="flex" gap={2} alignItems="center">
        <TextField
          label="New Slot Time"
          value={newSlot.time}
          onChange={(e) => setNewSlot({ ...newSlot, time: e.target.value })}
        />
        <TextField
          label="Max"
          type="number"
          value={newSlot.max}
          onChange={(e) => setNewSlot({ ...newSlot, max: +e.target.value })}
        />
        <Button variant="contained" onClick={addSlot}>
          Add Slot
        </Button>
      </Box>

      <Box mt={3} display="flex" gap={2}>
        <Button variant="outlined" onClick={resetSlots} startIcon={<Restore />}>
          Reset All
        </Button>
        <Button variant="contained" color="primary" onClick={saveAll}>
          Save Changes
        </Button>
      </Box>

      <SeedAvailabilitySection />
    </Box>
  );
};

export default AdminSlotManager;
